export default {
  name: 'icon-unable-svg'
};